import { vuex_subscribe_module, vuex_store_config } from '@/vuex';
import { load_state_from_local_storage } from '@/resources';
import { is_set } from '@/utilities';

const vuex_config_object = {
  location: {
    label: '',
    latitude: '',
    longitude: '',
    match_level: '',
  },
  checkin: '',
  checkout: '',
  hotels: [],
  selected_hotel: {},
  hotel_details: [],
  current_search: '',
  rooms_selection: {
    model_products: [],
    product_quantities: {},
  },
  selected_solution: {},
  // stanze aggiunte dalle soluzioni consigliate, per prodotto (chiave "room:product").
  // Valore "ratchet": può solo diminuire con le deselezioni manuali, non risalire.
  suggested_selections: {},
  resume: {}, // recap dei prezzi
  last_search: '',
  trigger_search: false,

  // V4 filters
  sorters: [],
  filters_structure: [],
  filters_selection: {},
  suggestion_sections: [],
  filter_availability: false,
  filter_poi: {
    ext_id: null,
  },

  // V4 sorting
  sort: {
    by: '',
    direction: '',
  },
};

export const serialized_vuex_config_object = JSON.stringify(vuex_config_object);

const state_config = vuex_store_config(vuex_config_object);

const name = 'livebkv3';
const { state } = state_config;
const module = {
  namespaced: true,
  state: load_state_from_local_storage(name, state_config.state),
  mutations: {
    ...state_config.mutations,

    // aggiunge/aggiorna i prodotti nell'accommodation
    update_accommodation_products(_state, products) {
      _state.selected_solution.accommodation = {
        ..._state.selected_solution.accommodation,
        products,
      };
    },

    // setta il valore di multiroom_assignment
    set_multiroom_assignment(_state, payload) {
      _state.selected_solution.accommodation.multiroom_assignment = payload;
    },

    // scrive l'occupancy_mismatch (da /orders/preview) sui prodotti dell'accommodation.
    // `mismatches` è allineato per indice all'array products inviato alla quote.
    set_products_occupancy_mismatch(_state, mismatches) {
      _state.selected_solution.accommodation.products =
        _state.selected_solution.accommodation.products.map((product, index) => ({
          ...product,
          occupancy_mismatch: (mismatches && mismatches[index]) || null,
        }));
    },

    // aggiorna rooms_selection
    update_rooms_selection(_state, payload) {
      _state.rooms_selection = {
        ..._state.rooms_selection,
        ...payload,
      };
    },
    // aggiorna selected_solution
    update_selected_solution(_state, payload) {
      _state.selected_solution = {
        ..._state.selected_solution,
        ...payload,
      };
    },
  },
  getters: state_config.getters,
  actions: state_config.actions,
  get_local_storage_submodule() {
    // dichiaro le chiavi che verranno scritte nel local storage
    return {
      location: state_config.state.location,
      checkin: state_config.state.checkin,
      checkout: state_config.state.checkout,
      last_search: state_config.state.last_search,
      current_search: state_config.state.current_search,
      selected_hotel: state_config.state.selected_hotel,
      hotel_details: state_config.state.hotel_details,
      selected_solution: {},
      resume: {},

      // V4 filter
      sorters: state_config.state.sorters,
      filters_structure: state_config.state.filters_structure,
      filters_selection: state_config.state.filters_selection,
      suggestion_sections: state_config.state.suggestion_sections,
      filter_availability: state_config.state.filter_availability,

      // V4 sort
      sort: state_config.state.sort,
    };
  },
};

export function register_state_module(prototype) {
  if (!is_set(prototype.$submodules)) prototype.$submodules = {};
  prototype.$submodules[name] = {
    get_local_storage_submodule: module.get_local_storage_submodule(),
  };
  vuex_subscribe_module(name, state, module);
}
